import { Dashboard } from '../../types/types';
import TableActionRow, { TableActionRowProps } from '../TableActionRow/TableActionRow';

import styles from './DashboardInfo.module.scss';

interface DashboardInfoProps extends TableActionRowProps {
  data: Dashboard[];
  rowHeaderRenderer: React.FC<Dashboard>;
  actionRenderer: React.FC<Dashboard>;
}

export const DashboardInfo = ({
  data,
  rowHeaderRenderer,
  actionRenderer,
  ...tableActionRowProps
}: DashboardInfoProps) => {
  return (
    <div>
      <div className={styles.headerWrapper}>
        <TableActionRow placeholder="Dashboard name or description" {...tableActionRowProps} />
      </div>
      <div className={styles.container}>
        {data.map((item) => (
          <div key={item.id} className={styles.infoRow}>
            <div className={styles.title}>{rowHeaderRenderer(item)}</div>
            <div className={styles.rowActions}>{actionRenderer(item)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
